var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentbox"},[_c('recharge-return-list-info',{attrs:{"tfId":_vm.tfId}}),_c('agent-pop',{attrs:{"visible":_vm.isShowDialogAgent},on:{"update:visible":function($event){_vm.isShowDialogAgent=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }